import { TOGGLE_MODAL } from '../actions/actionTypes';
import initialState from './initialState';

export default (state = initialState.modals, action = {type: ''}) => {
    switch (action.type) {
        case TOGGLE_MODAL:
            if (state.includes(action.payload)) {
                return state.filter(item => item !== action.payload);
            }
            return [ ...state, action.payload ];
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/modalReducer.js